import { SavedEcpFieldNames } from "checkout-query-client/types/chex-form-fields";
import { FormConfig, InputType } from "checkout-query-client/types/form-types";

export const savedEcpFormConfig: FormConfig<SavedEcpFieldNames> = {
  active: true,
  title: "Ending in  ••••{{number}}",
  inputs: [
    {
      id: "nameOnAccount",
      type: InputType.text,
      active: true,
      grid: {
        small: {},
        medium: {},
        large: {},
      },
    },
    {
      id: "billingTitle",
      type: InputType.subTitle,
      active: true,
      grid: {
        small: {
          marginTop: "2",
        },
        medium: {
          marginTop: "2",
        },
        large: {
          marginTop: "2",
        },
      },
    },
    {
      id: "currentShippingAddressWithEdit",
      type: InputType.currentAddressWithEdit,
      initialValue: "false",
      active: true,
      grid: {
        small: {
          marginTop: "-2",
          marginBottom: "2",
        },
        medium: {
          marginTop: "-2",
          marginBottom: "2",
        },
        large: {
          marginTop: "-2",
          marginBottom: "2",
        },
      },
    },
    {
      id: "billingAddressCountry",
      type: InputType.select,
      initialValue: "US",
      active: true,
      autocomplete: "country-name",
      grid: {
        small: {},
        medium: {},
        large: {},
      },
    },
    {
      id: "billingAddressAddressLine1",
      type: InputType.autocomplete,
      initialValue: "",
      active: true,
      autocomplete: "address-line1",
      grid: {
        small: {},
        medium: {},
        large: {},
      },
    },
    {
      id: "billingAddressAddressLine2",
      type: InputType.text,
      initialValue: "",
      active: true,
      autocomplete: "address-line2",
      grid: {
        small: {},
        medium: {},
        large: {},
      },
    },
    {
      id: "billingAddressCity",
      type: InputType.text,
      initialValue: "",
      autocomplete: "address-level2",
      active: true,
      grid: {
        small: {},
        medium: {},
        large: {},
      },
    },
    {
      id: "billingAddressAdministrativeArea",
      type: InputType.dynamic,
      initialValue: "",
      autocomplete: "address-level1",
      active: true,
      grid: {
        small: {
          flex: "0.5",
        },
        medium: {
          flex: "0.5",
        },
        large: {
          flex: "0.5",
        },
      },
    },
    {
      id: "billingAddressZip",
      type: InputType.text,
      initialValue: "",
      autocomplete: "postal-code",
      active: true,
      grid: {
        small: {
          flex: "0.5",
        },
        medium: {
          flex: "0.5",
        },
        large: {
          flex: "0.5",
        },
      },
    },
    {
      id: "setAsDefault",
      type: InputType.checkbox,
      initialValue: "false",
      active: true,
      grid: {
        small: {},
        medium: {},
        large: {},
      },
    },
  ],
};
